export const FETCH_DATA_OPTIONS = `OPTIONS/FETCH_DATA`;
export const FETCH_DATA_OPTIONS_REQUEST = `${FETCH_DATA_OPTIONS}_REQUEST`;
export const FETCH_DATA_OPTIONS_SUCCESS = `${FETCH_DATA_OPTIONS}_SUCCESS`;
export const FETCH_DATA_OPTIONS_FAILURE = `${FETCH_DATA_OPTIONS}_FAILURE`;

export const SAVE_DATA_OPTIONS = `OPTIONS/SAVE_DATA`;
export const SAVE_DATA_OPTIONS_REQUEST = `${SAVE_DATA_OPTIONS}_REQUEST`;
export const SAVE_DATA_OPTIONS_SUCCESS = `${SAVE_DATA_OPTIONS}_SUCCESS`;
